import('./bootstrap');

if (typeof process === 'undefined') {
	global.process = require('process');
}
